import { IDeleteObraInformacoesUseCase } from "../../../presentation/useCases/delete/delete_obra_informacoes_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteInformacaoObraUseCase
 */

export class DeleteObraInformacoesUseCase implements IDeleteObraInformacoesUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteObraInformacoes(
    idObraInformacoes: number,
  ): Promise<void> {
    await this.repository.deleteObraInformacoes(idObraInformacoes)
  }
}
